module.exports = __webpack_public_path__ + "50f461814e274ff6176556aaa7b6215b.jpg";